import BackIcon from "@material-ui/icons/ArrowBackIosRounded";
import React from "react";
import { RelativeButtonLinkProps, RelativeIconLink } from "../../index";
import IconButton from "@material-ui/core/IconButton";

export interface GoBackButtonProps
  extends Pick<
    RelativeButtonLinkProps,
    Exclude<keyof RelativeButtonLinkProps, "to">
  > {
  goBack?: () => any;
}

export const GoBackButton = (props: GoBackButtonProps) => {
  const { goBack, ...rest } = props;

  return goBack ? (
    <IconButton aria-label="Go Back" color="primary" onClick={goBack}>
      <BackIcon />
    </IconButton>
  ) : (
    <RelativeIconLink to="^" {...rest} color="primary" icon={<BackIcon />} />
  );
};
